module.exports = __webpack_public_path__ + "static/media/img_01.087e1bdd.jpg";